/**
 * 커서 물결의 <b>생김새</b>만 담은 파일 (2026-09-18 분리).
 *
 * <p>컴포넌트(`LoginWaves.tsx`)에서 떼어낸 이유는 <b>앱이 이 문자열을 가져다 쓰기</b> 때문이다.
 * 앱은 이 효과를 WebView 한 장으로 띄우는데(`mobile/src/ui/LoginWaves.tsx`), 컴포넌트 파일을
 * 통째로 부르면 그 안의 JSX 가 앱 설정(nativewind jsx-runtime)으로 검사돼 막힌다.
 *
 * <p>여기 있는 한 줄이 «물결» 의 전부다 — `transition-property: cx,cy` 와 고리마다 다른 전환
 * 시간이 만나 바깥 고리일수록 늦게 도착한다. 두 벌로 베끼면 그 값이 갈라진다.
 */
export const LOGIN_WAVES_STYLES = `
.lwx{position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:2}
.lwx svg{position:absolute;inset:0;width:100%;height:100%;display:block}
.lwx circle{transition-property:cx,cy;transition-timing-function:linear}
`;
